import type { FaireProductEntity } from "../../entity_types/product";

export const p_d6qxmdzf: FaireProductEntity = {
  token: "p_d6qxmdzf",
  type: "product",
  name: "Grazie Thank You Greeting Card - Box of 6",
  brandToken: "b_6pxaaxfg",
  brandName: "La Familia Green",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/ca8158e04c8b4ca98044d3b93b1017fd9040acb0844466844f74bc516541b448/1535728726.jpg",
  galleryImageUrls: [],
  priceDollars: 8.5,
  description:
    'Grazie is Italian for thanks. And spaghetti is Italian for yum.\n\nFlat printed on FSC certified paper from an original handcut collage, drawing, or print.\n\nBox of six 4.25" x 5.5" folded cards with recycled kraft envelopes.\n\nBlank inside\n\nMade in USA',
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:08.816Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
